require("./budget-direct.js");
require("./budget-direct.scss");
require("./partner-tools.scss");

(function($) {
    $(function() {
        var $ctl = $(".partner-tools-wrapper");

        $.get($ctl.data("url"))
            .done(function(rsp) {
                $ctl.html(rsp);
                $(document).click(function() { 
                  if ($('.tooltip:visible').length){
                    $('[data-toggle="tooltip"]').tooltip('hide');
                  }
                  });
                $('[data-toggle="tooltip"]').tooltip({
                  delay: { "show": 200}
                });              
                CsnImpressionTracker.track();
            })
            .fail(function(rsp) {
                console.log("failed to get partner-tools");
            });
    });
})(jQuery);